module.exports = "/cyber/_next/static/images/hero-bg-desktop-297dd4278514fc2a6fdeaf4ca9cf4652.jpg";